module.exports = __webpack_public_path__ + "img/mrsdigibanner.96145912.png";